import React, { useCallback, useState } from 'react'

import {
    autoUpdate,
    useClick,
    useDismiss,
    useFloating,
    useInteractions,
} from '@floating-ui/react'

import { ButtonV2, CheckboxV2, Typography } from '../'

import { Popover } from './components'
import { Body, BottomPart, MainPart, TopPart, middleware } from './store'


export const CheckboxPickerV2 = ({
    title = 'Filter',
    titleGroup = 'Treat level',
    options,
    onChange,
}) => {
    const [isOpen, setIsOpen] = useState(false)
    const [selectedCheckboxes, setSelectedCheckboxes] = useState([])

    const { context, refs, floatingStyles } = useFloating({
        open: isOpen,
        placement: 'bottom-start',
        onOpenChange: setIsOpen,
        middleware,
        whileElementsMounted: autoUpdate,
        strategy: 'fixed',
    })

    const onClose = useCallback(() => setIsOpen(false), [])

    const click = useClick(context)
    const dismiss = useDismiss(context)

    const { getReferenceProps, getFloatingProps } = useInteractions([
        dismiss,
        click,
    ])

    const handleCheckboxChange = (label) => {
        const selected = selectedCheckboxes.includes(label)
            ? selectedCheckboxes.filter(item => item !== label)
            : [...selectedCheckboxes, label]

        setSelectedCheckboxes(selected)

        onChange(selected)
    }

    const checkedCount = selectedCheckboxes.length
    const buttonText =
        checkedCount > 0 ? `Filter: ${checkedCount} selected` : 'Set filter'
    return (
        <div>
            <ButtonV2
                variant="greenSmoke"
                getReferenceProps={getReferenceProps}
                refs={refs}
                onClick={() => setIsOpen(true)}
            >
                {buttonText.toUpperCase()}
            </ButtonV2>

            {isOpen && (
                <Popover
                    refs={refs}
                    floatingStyles={floatingStyles}
                    getFloatingProps={getFloatingProps}
                >
                    <Body>
                        <TopPart>
                            <Typography variant="h6">{title}</Typography>
                        </TopPart>

                        <MainPart>
                            <Typography variant="subtitle1">{titleGroup}</Typography>

                            {options.map((label, index) => (
                                <CheckboxV2
                                    key={index}
                                    label={label}
                                    checked={selectedCheckboxes.includes(label)}
                                    onChange={() => handleCheckboxChange(label)}
                                    name={label}
                                />
                            ))}
                        </MainPart>
                    </Body>

                    <BottomPart>
                        <ButtonV2
                            width="100%"
                            size="small"
                            variant="greenSmoke"
                            onClick={onClose}
                        >
                            Close
                        </ButtonV2>
                    </BottomPart>
                </Popover>
            )}
        </div>
    )
}
